import { createRoute, redirect } from '@tanstack/react-router';
import type { EzyModule } from '../module';

// Màn Nhân sự đã chuyển sang HANA Mee › NHÂN SỰ (/mee/hr…, 02/Nov). Route cũ /ezy/hr… giữ redirect, giữ nguyên đuôi + query.
const go = (to: string) => ({ location }: { location: { search: unknown } }) => {
  throw redirect({ to, search: location.search as never });
};
const R = (parent: Parameters<NonNullable<EzyModule['routes']>>[0], path: string, to: string) =>
  createRoute({ getParentRoute: () => parent, path, beforeLoad: go(to) });

const hr: EzyModule = {
  routes: (parent) => [
    R(parent, '/hr', '/mee/hr'),
    R(parent, '/hr/contract', '/mee/hr/contract'),
    R(parent, '/hr/decision', '/mee/hr/decision'),
    createRoute({ getParentRoute: () => parent, path: '/hr/decision/$no', beforeLoad: ({ params, location }) => { throw redirect({ to: `/mee/hr/decision/${params.no}`, search: location.search as never }); } }),
    R(parent, '/hr/kpi', '/mee/hr/kpi'),
    R(parent, '/hr/profile', '/mee/hr/profile'),
    createRoute({ getParentRoute: () => parent, path: '/hr/profile/$staffId', beforeLoad: ({ params, location }) => { throw redirect({ to: `/mee/hr/profile/${params.staffId}`, search: location.search as never }); } }),
  ],
};
export default hr;
